module.exports = __webpack_public_path__ + "static/media/fortlev_solar_vetor.bf71097b.svg";